import React, { FunctionComponent } from 'react';
import { AEMContent } from '@mlc/web-ui-toolkit';
import ErrorPage from './ErrorPage';

const NotFound: FunctionComponent = () => (
	<ErrorPage
		headerMessage="Oops! Something went wrong"
		message="We are unable to provide a service at this time"
	>
		<AEMContent path="/secure/_content/common/error" />
	</ErrorPage>
);

export default NotFound;
